import { useEffect } from 'react'
import { Flex, Box } from '@chakra-ui/react'
import { Outlet, useNavigate } from 'react-router-dom'

import { getProfileSettings } from '@/api/settings.api'
import { endUserSession } from '@/providers/auth/session'
import { useUserStore } from '@/stores/user.store'
import { SUPPORT_PORTAL_URL } from '@/config'
import UnionTopNav from '@/components/navigation/UnionTopNav'
import { getUserDisplayName } from '@/helper/common.helper'

/**
 * Layout for the Union manager area (`/app/manager/*`). The top navigation links to the
 * section routes declared in App.tsx; the active section renders through the outlet.
 */
export default function UnionDashboard() {
  const { user, profile, setProfile } = useUserStore()
  const profileDisplayName = getUserDisplayName(user, profile)
  const navigate = useNavigate()

  useEffect(() => {
    let alive = true

    ;(async () => {
      try {
        const data = await getProfileSettings()
        if (!alive) return
        setProfile(data)
      } catch (e) {
        console.error('Failed to load profile settings:', e)
      }
    })()

    return () => {
      alive = false
    }
  }, [setProfile])

  const logout = async () => {
    // Central teardown (SIB-924): server logout + full client session reset,
    // including the user store. Local cleanup happens even if the server call fails.
    await endUserSession()
    navigate('/login', { replace: true })
  }

  return (
    <Flex direction="column" minH="100vh" bg="bg">
      <UnionTopNav
        displayName={profileDisplayName || 'Union Investment'}
        onLogout={logout}
        onSupport={() => window.open(SUPPORT_PORTAL_URL, '_blank')}
      />

      <Box px={{ base: 4, md: 6 }} py={4}>
        <Flex direction="column" bg="bg" overflow="hidden">
          <Outlet />
        </Flex>
      </Box>
    </Flex>
  )
}
